<template>
  <div class="bonusManagement h100">
    <el-card>
      <el-table class="table-bonus-year" ref="tableData" :data="bonusVersionList" height="201" border header-cell-class-name="headerStyle" cell-class-name="cellStyle" :row-class-name="tableRowClassName">
        <el-table-column label="奖金版本">
          <template slot-scope="scope">
            <span class="cur_p" @click="getQuarterBonusList_TABLE(scope.$index, scope.row)">{{scope.row.versionName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="createUser" label="创建人"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <el-table-column prop="updateUser" label="修改人"></el-table-column>
        <!-- <el-table-column prop="policyUploadTime" label="政策上传时间"></el-table-column> -->
        <!-- <el-table-column prop="policyFileName" label="政策文档"></el-table-column> -->
        <!-- <el-table-column prop="" label="政策上传" width="100">
          <template slot-scope="scope">
            <el-upload ref="uploadRef" :multiple='false' action :http-request="upload" :data={id:scope.row.id} :show-file-list='false' :before-upload="beforeUpload">
              <i class="el-icon-upload2 downloadIcon"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="updateUser" label="政策下载" width="100">
          <template slot-scope="scope">
            <i class="el-icon-download downloadIcon" @click="download(scope.row)"></i>
          </template>
        </el-table-column> -->
      </el-table>
      <el-tabs class="menu-tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="起奖设定" name="1">
          <bonusSetting ref="bonusSettingRef" :activeNameChild='activeNameChild' @activeNameChildChange="activeNameChildChange"></bonusSetting>
        </el-tab-pane>
        <!-- <el-tab-pane label="人岗关系" name="6">
          <userPositionMapping ref="userPositionMappingRef"></userPositionMapping>
        </el-tab-pane> -->
        <el-tab-pane label="数据模板配置" name="2">
          <dataTemplate ref="DataTemplate"></dataTemplate>
        </el-tab-pane>
        <el-tab-pane label="数据上传" name="3">
          <uploadData ref="uploadData" :activeNameChild='activeNameChild' @activeNameChildChange="activeNameChildChange"></uploadData>
        </el-tab-pane>
        <el-tab-pane label="特调" name="4">
          <specialAdjustment ref="specialAdjustment"></specialAdjustment>
        </el-tab-pane>
        <el-tab-pane label="奖金调整和发布" name="5">
          <adjustPublish ref="adjustPublish"></adjustPublish>
        </el-tab-pane>
        <!-- <el-tab-pane label="奖金预算" name="5">
          <bonusForecast ref="bonusForecast"></bonusForecast>
        </el-tab-pane> -->
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import bonusSetting from './bonusSetting.vue'
import dataTemplate from './dataTemplate.vue'
import uploadData from './uploadData.vue'
import specialAdjustment from './specialAdjustment.vue'
import adjustPublish from './adjustPublish.vue'
// import bonusForecast from './bonusForecast.vue'
export default {
  name: 'bonusManagement',
  components: {
    bonusSetting,
    dataTemplate,
    uploadData,
    specialAdjustment,
    adjustPublish
    // bonusForecast
  },
  data () {
    return {
      bonusVersionList: [], // 全年奖金列表
      activeName: '1',
      activeNameChild: '0', // 数据上传默认展示第一项
      highLight: 0, // 高亮行
      versionName: ''
    }
  },
  created () {
    // 调用年度奖金版本列表
    this.getBonusVersionList()
  },
  mounted () {},
  methods: {
    // 年度奖金版本列表
    getBonusVersionList () {
      this.bonusVersionList = []
      this.$http.get(this.API.incentiveVersionInfoList).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.bonusVersionList = data.data
          // 赋值年度版本号--默认第一项
          this.versionName = data.data[0].versionName
          // 起奖设定
          this.$refs.bonusSettingRef.getQuarterBonusList(this.versionName)
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 点击table调用季度奖金列表
    getQuarterBonusList_TABLE (index, row) {
      // console.log(index)
      // 高亮根据index确定--0开始
      this.highLight = index
      // 数据上传默认展示第一项
      this.activeNameChild = '0'
      // 更新赋值年度版本号
      this.versionName = row.versionName
      // 起奖设定
      this.$refs.bonusSettingRef.getQuarterBonusList(row.versionName)
      // 调用数据模板
      this.$refs.DataTemplate.versionName = row.versionName
      this.$refs.DataTemplate.getDataTemplateList()
      this.$refs.DataTemplate.selectedData(row.versionName)
      // 调用数据上传--季度奖金列表
      this.$refs.uploadData.getQuarterBonusList(row.versionName)
      // 特调--季度奖金列表
      this.$refs.specialAdjustment.getAdjustmentList(row.versionName)
      // 调用奖金调整--季度奖金列表
      this.$refs.adjustPublish.getQuarterBonusList(row.versionName)
      // 调用奖金调整--处理筛选器和表格清空
      this.$refs.adjustPublish.tableDataAdjust = []
      this.$refs.adjustPublish.searchList = {
        region: null,
        city: null,
        employeeNm: null,
        roleLevel: null,
        kpi: null,
        incentiveRate: null,
        isAdjust: null,
        kpiAch: null
      }
      this.$refs.adjustPublish.region = []
      this.$refs.adjustPublish.city = []
      this.$refs.adjustPublish.employeeNm = []
      this.$refs.adjustPublish.roleLevel = []
      this.$refs.adjustPublish.kpi = []
      this.$refs.adjustPublish.incentiveRate = []
      this.$refs.adjustPublish.mudId = []
      this.$refs.adjustPublish.isAdjust = []
      // 试算版本--预算
      // this.$refs.bonusForecast.versionName = row.versionName
      // 调用KPI配置列表-预算
      // this.$refs.bonusForecast.getConfigKpiList(row.versionName)
    },
    // 上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      const isExcel = file.type === 'application/pdf'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('上传模板只能是PDF格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传模板大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
      return isExcel
    },
    // 上传
    upload (row) {
      // console.log(e)
      let formData = new FormData()
      formData.append('id', row.data.id)
      formData.append('file', row.file)
      this.$http.post(this.API.policyUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        this.$message.success('政策上传成功！')
        // 年度奖金版本列表
        this.getBonusVersionList()
      })
    },
    // 下载
    download (row) {
      if (row.policyFileName === null) {
        this.$message.warning('暂未上传政策！')
      } else {
        this.$http.get(this.API.policyDownload, { params: { id: row.id }, responseType: 'blob' }).then(res => {
        // console.log(res)
          let blob = new Blob([res.data], { type: res.data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = row.policyFileName // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        })
      }
    },
    // 子组件改变active值
    activeNameChildChange (par) {
      this.activeNameChild = par
    },
    // 修改table列样式--根据columnIndex--0开始
    columnStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'color:#337ab8;cursor:pointer'
      }
    },
    // 高亮行
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === this.highLight) {
        return 'success-row'
      }
      return ''
    },
    // tabs切换形式
    handleClick (tab, event) {
      // console.log(tab)
      if (tab.label === '起奖设定') {
        // 起奖设定
        this.$refs.bonusSettingRef.getQuarterBonusList(this.versionName)
      } else if (tab.label === '数据模板配置') {
        // 初始化数据模板
        this.$refs.DataTemplate.versionName = this.versionName
        this.$refs.DataTemplate.getDataTemplateList()
        this.$refs.DataTemplate.selectedData(this.versionName)
      } else if (tab.label === '数据上传') {
        // 初始化数据上传--季度奖金列表
        this.$refs.uploadData.getQuarterBonusList(this.versionName)
      } else if (tab.label === '特调') {
        // 特调--季度奖金列表
        this.$refs.specialAdjustment.getAdjustmentList(this.versionName)
      } else if (tab.label === '奖金调整和发布') {
        // 初始化奖金调整--季度奖金列表
        this.$refs.adjustPublish.getQuarterBonusList(this.versionName)
      } else if (tab.label === '奖金预算') {
        // 初始化年度奖金预算列表-？？？
        this.$refs.bonusForecast.getFcstData(this.versionName)
        // 调用KPI配置列表-？？？
        this.$refs.bonusForecast.getConfigKpiList(this.versionName)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bonusManagement {
  // table选中颜色
  /deep/.el-table .success-row {
    background: #f0f9eb;
  }
  // 未知
  // /deep/.el-table__body tr.current-row > td {
  //   background-color: #e1f5fe;
  // }
  .menu-tabs {
    margin-top: 15px;
    /deep/.el-tabs__item {
      border: 1px solid #eee;
      border-left: none;
    }
    /deep/.el-tabs__active-bar {
      height: 0;
    }
    /deep/.el-tabs__item.is-active {
      // 选中颜色
      // 蓝色
      // background-color: #337ab8;
      // 青色
      background-color: #007F90;
      color: #fff;
    }
    /deep/.el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px;
      border-left: 1px solid #eee;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    /deep/.el-tabs__item.is-top:last-child {
      padding-right: 20px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    /deep/.el-tabs__nav-scroll {
      text-align: center;
    }
    /deep/.el-tabs__nav {
      float: none;
    }
  }
}
</style>
